import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/* Fixed bottom tab bar for the customer shell (mobile-first). Four tabs —
   Home / Schedule / Songs / More. It is `position: fixed` (customerShell.css),
   so it overlays the scroll and fills env(safe-area-inset-bottom); the shell's
   content column carries a matching bottom padding so nothing hides under it.

   Active state is derived from the pathname rather than <NavLink> because the
   More tab must light up for its whole family of secondary destinations
   (payments / account / family / announcements / calendar), not just /more. */

const TABS = [
	{ key: 'home', label: 'Home', icon: 'fa-house', to: '/portal/customer' },
	{
		key: 'schedule',
		label: 'Schedule',
		icon: 'fa-calendar-days',
		to: '/portal/customer/schedule',
	},
	{ key: 'songs', label: 'Songs', icon: 'fa-music', to: '/portal/customer/songs' },
	{ key: 'more', label: 'More', icon: 'fa-ellipsis', to: '/portal/customer/more' },
];

// Which sub-paths light up which tab. Schedule owns the makeup redeem surface;
// More owns every secondary destination it links to.
const activeTab = (pathname) => {
	const p = pathname.replace(/\/+$/, '') || '/portal/customer';
	if (p === '/portal/customer') return 'home';
	if (p.startsWith('/portal/customer/schedule') || p.startsWith('/portal/customer/makeup'))
		return 'schedule';
	if (p.startsWith('/portal/customer/songs')) return 'songs';
	// Everything else under the customer tree is a More destination.
	return 'more';
};

function CustomerTabBar() {
	const { pathname } = useLocation();
	const active = activeTab(pathname);

	return (
		<nav className='cust-tabbar' aria-label='Customer portal'>
			<ul className='cust-tabbar__list'>
				{TABS.map((t) => {
					const on = t.key === active;
					return (
						<li key={t.key} className='cust-tabbar__item'>
							<Link
								to={t.to}
								className={`cust-tabbar__link${on ? ' is-active' : ''}`}
								aria-current={on ? 'page' : undefined}>
								<i
									className={`fa-sharp fa-solid ${t.icon} cust-tabbar__icon`}
									aria-hidden='true'
								/>
								<span className='cust-tabbar__label'>{t.label}</span>
							</Link>
						</li>
					);
				})}
			</ul>
		</nav>
	);
}

export default CustomerTabBar;
